import { render, staticRenderFns } from "./coefficient-list.vue?vue&type=template&id=16d78d28&scoped=true"
import script from "./coefficient-list.vue?vue&type=script&lang=js"
export * from "./coefficient-list.vue?vue&type=script&lang=js"
import style0 from "./coefficient-list.vue?vue&type=style&index=0&id=16d78d28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d78d28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d78d28')) {
      api.createRecord('16d78d28', component.options)
    } else {
      api.reload('16d78d28', component.options)
    }
    module.hot.accept("./coefficient-list.vue?vue&type=template&id=16d78d28&scoped=true", function () {
      api.rerender('16d78d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dollars/coefficient-list.vue"
export default component.exports